import { gate } from 'hub-http/gates';
import { useIsUngated } from '../hooks/useIsUngated';
export const GATE_UBB_UNIFIED_CREDITS = gate('HubSpotCredits');
export const GATE_UBB_HUBSPOT_CREDITS_INBOUND = gate('UBBFE:HubSpotCreditsInbound');
export const GATE_CUSTOMER_AGENT_BETA = gate('UsageBasedBilling:CAZeroCreditSpend');
export const GATE_CA_BETA_USAGE_UX = gate('UBBFE:BetaUsage');

/**
 * Hook to check if the current portal is ungated for the HubSpot Credits Inbound gate
 * @returns boolean indicating if the portal is ungated
 */
export function useIsUngatedForHubSpotCreditsInboundGate() {
  return useIsUngated(GATE_UBB_HUBSPOT_CREDITS_INBOUND);
}
export function useIsUngatedForCABetaUsageUXGate() {
  return useIsUngated(GATE_CA_BETA_USAGE_UX);
}